import { MANAGE_AREAS } from '../cms/manageAreas';

/** Help & feedback (HelpFeedback.tsx): what a report says about who and where. */

/** The screen's name, as the person knows it (Content, Reach, Account settings…). */
export function screenName(path: string, search = ''): string {
  const query = new URLSearchParams(search);
  const view = query.get('view');
  // Pages that aren't articles, under /content.
  if (path.startsWith('/content/forms/settings')) return 'Website › Forms › Settings';
  if (path.startsWith('/content/settings')) return 'Website › Articles › Settings';
  if (path.startsWith('/content') && view === 'manage') {
    const area = MANAGE_AREAS.find(([key]) => key === query.get('area'));
    return area ? `Website › Manage › ${area[1]}` : 'Website › Manage';
  }
  if (/^\/content\/[^/]+/.test(path) && !path.startsWith('/content/new')) return 'Article';
  if (path.startsWith('/content/new')) return 'New article';
  if (path.startsWith('/content')) {
    const sub = view ? view.charAt(0).toUpperCase() + view.slice(1) : '';
    return sub ? `Website › ${sub}` : 'Website';
  }
  const PLACES: Array<[string, string]> = [
    ['/today', 'Today'],
    ['/campaigns', 'Campaigns'],
    ['/reach', 'Social'],
    ['/prism-ai', 'Prism AI'],
    ['/media', 'Media'],
    ['/site', 'Website › Manage › Site'],
    ['/settings', 'Account settings'],
    ['/profile', 'Profile'],
    ['/sites', 'Sites'],
    ['/addons', 'Add-ons'],
  ];
  const hit = PLACES.find(([p]) => path === p || path.startsWith(`${p}/`));
  return hit ? hit[1] : 'tinycms';
}

/** "Chrome", "Safari", "Firefox", "Edge"… and the fuller line sent with a report. */
export function browserOf(ua: string): { name: string; full: string } {
  const pick = (re: RegExp) => re.exec(ua)?.[1];
  let name = 'Browser';
  let version: string | undefined;
  if ((version = pick(/Edg\/(\d+)/))) name = 'Edge';
  else if ((version = pick(/OPR\/(\d+)/))) name = 'Opera';
  else if ((version = pick(/Firefox\/(\d+)/))) name = 'Firefox';
  else if ((version = pick(/(?:Chrome|CriOS)\/(\d+)/))) name = 'Chrome';
  else if (/Safari\//.test(ua)) {
    name = 'Safari';
    version = pick(/Version\/(\d+(?:\.\d+)?)/);
  }
  const os = /iPhone|iPad|iPod/.test(ua)
    ? 'iOS'
    : /Android/.test(ua)
      ? 'Android'
      : /Mac OS X/.test(ua)
        ? 'macOS'
        : /Windows/.test(ua)
          ? 'Windows'
          : /Linux/.test(ua)
            ? 'Linux'
            : '';
  return { name, full: [name, version].filter(Boolean).join(' ') + (os ? ` on ${os}` : '') };
}

/** "Hai" from hai@blueline.io (the app has no stored name; the server does the same). */
export function nameFromEmail(email: string): string {
  const local = String(email || '').split('@')[0] || '';
  return local ? local.charAt(0).toUpperCase() + local.slice(1) : '';
}
